module.exports = __webpack_public_path__ + "static/img/luckyBag.68d2dcd0.png";